<div class="col-sm-11 center-block">
            <div [@fadeInOut] class="row">
                <div class="col-sm-12 extra-top-space">
                    <a class="pointer gray-link" (click)="navigateToFileUpload()"><i class="fa fa-caret-left"></i> Back to File Upload</a>
                </div>
            </div>
            <div [@fadeInOut] *ngIf="!error">
                <div class="row">
                    <div class="col-sm-12">
                        <h1>File Details - Import Id: {{fileDetailsStats?.importId}}</h1>
                        <div class="card bg-default">
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-sm-4 col-md-3">
                                        <label>File Name</label>
                                        <h2 *ngIf="fileDetailsStats" class="break-long-words">
                                            {{fileDetailsStats?.fileName}}
                                        </h2>
                                    </div>
                                    <div class="col-sm-4 col-md-3">
                                        <label>Importer Name</label>
                                        <h2 *ngIf="fileDetailsStats" class="break-long-words">
                                            {{fileDetailsStats?.fileUploadedBy}}
                                        </h2>
                                    </div>
                                    <div class="col-sm-4 col-md-3">
                                        <label>Ingestion Date</label>
                                        <h2 *ngIf="fileDetailsStats">
                                            {{fileDetailsStats?.uploadDate | date:'shortDate'}} <!--MM/dd/yyyy-->
                                        </h2>
                                    </div>
                                    <div class="col-sm-4 col-md-3">
                                        <label>Ingestion Time</label>
                                        <h2 *ngIf="fileDetailsStats">
                                            {{fileDetailsStats?.uploadDate | date:'shortTime'}}
                                        </h2>
                                    </div>
                                </div>
                                <div class="row extra-top-space">
                                    <div class="col-sm-4 col-md-3">
                                        <label>Ingestion Status</label>
                                        <div class="status">
                                            <div class="status-block" [ngClass]="getCSSClasses()"></div>
                                            <h2 *ngIf="fileDetailsStats">
                                                {{fileDetailsStats?.fileOutcome}}
                                            </h2>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 col-md-3">
                                        <label>Total number of items imported successfully</label>
                                        <h2 *ngIf="fileDetailsStats">
                                            {{fileDetailsStats?.importedSuccessfully}}
                                        </h2>
                                    </div>
                                    <div class="col-sm-4 col-md-3">
                                        <label>Total number of exceptions in the file</label>
                                        <h2 *ngIf="fileDetailsStats">
                                            {{fileDetailsStats?.rejected}}
                                        </h2>
                                    </div>
                                    <div class="col-sm-4 col-md-3">
                                        <label>Total Number of records in the file</label>
                                        <h2 *ngIf="fileDetailsStats">
                                            {{fileDetailsStats?.totalCount}}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <h1>Item Details</h1>
                        <h2>{{fileDetailsStats?.importedSuccessfully}} Item(s) Imported Successfully</h2>
                        <!--Successful grid-->
                        <ejs-grid #gridSuccess id='eGridSuccess' [dataSource]='successData' allowPaging='true'
                                  allowSorting='true' allowFiltering='true' allowExcelExport='true' height="315">
                            <e-columns>
                                <e-column field='keyIdentifier' headerText='Key Identifier Number' width='60' textAlign="left">
                                </e-column>
                                <e-column field='keyAgency' headerText='Key Identifier Issuing Agency' width='80'></e-column>
                                <e-column field='brandName' headerText='Trade Name' width='80'></e-column>
                                <e-column field='itemType' headerText='Item Type' width='30'></e-column>
                                <e-column field='messageSeverity' headerText='Import Results' width='35'></e-column>
                                <e-column field='message' headerText='Message' width='120'></e-column>
                                <!--<e-column field='messageDate' headerText='Message Date/Time' width='60' type="date" [format]="gridDateFormat"></e-column>-->
                            </e-columns>
                        </ejs-grid>
                        <!--<input type="button" class="btn btn-primary exportButton" (click)="exportToExcel(true)" value="Export Successful Import Log" />-->
                        <!--Rejected grid-->
                        <!--<div class="col-sm-12 blue-bar">
                          <div class="blue-bar-internal">
                            {{fileDetailsStats.rejected}} Item(s) Rejected
                          </div>
                        </div>
                        <div *ngIf="rejectedData">
                          <ejs-grid #gridRejected id='eGridReject' [dataSource]='rejectedData' allowPaging='true'
                                    allowSorting='true' allowFiltering='true' allowExcelExport='true' height="315">
                            <e-columns>
                              <e-column field='lineNumber' headerText='Line Number' width='40' textAlign="center"></e-column>
                              <e-column field='keyFields' headerText='Item Identifier' width='60' textAlign="center"></e-column>
                              <e-column field='documentId' headerText='Document Id' width='80' textAlign="center" [visible]="false"></e-column>
                              <e-column field='itemType' headerText='Item Type' width='30' textAlign="center"></e-column>
                              <e-column field='messageSeverity' headerText='Import Results' width='30' textAlign="center"></e-column>
                              <e-column field='message' headerText='Message' width='120' textAlign="left"></e-column>
                              <e-column field='messageDate' headerText='Message Date/Time' width='60' type="date" [format]="gridDateFormat" textAlign="center"></e-column>
                            </e-columns>
                          </ejs-grid>
                          <input type="button" class="btn btn-primary" (click)="exportToExcel(false)" value="Export Failed Import Log" />
                        </div>-->
                    </div>
                </div>
            </div>
            <div *ngIf="error">
                <h2>{{error}}</h2>
            </div>

 </div>
